var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('SearchResultItem',{attrs:{"blogList":_vm.blogList}}),(_vm.blogList.length)?_c('Pagination',{attrs:{"getBlogList":_vm.getBlogList,"totalPage":_vm.totalPage}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }